import React from 'react';
import { Spinner } from '@chakra-ui/react';
import { colors } from 'constants/constants';

export default function BirdLoader(): JSX.Element {
  const [state, setState] = React.useState(false);

  React.useEffect(() => {
    const timeoutID = window.setTimeout(() => {
      setState(true);
    }, 600);
    return () => window.clearTimeout(timeoutID);
  }, []);

  if (!state) return null;

  // return <Image src="/images/loader.gif" width={80} height={80} />;
  return <Spinner color={colors.primary[900]} />;
}
